import axios from 'axios';
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import AnaliseReportTable from '../../components/AnaliseReportTable';
import AnaliseParameterPicker from '../../components/AnaliseParameterPicker';
import AnaliseReportLegenda from '../../components/AnaliseReportLegenda';
import AnaliseReportExportMenu from '../../components/AnaliseReportExportMenu';
import { rgbToArgb } from '../../utils';
import { API_HOST } from '../../consts';
import { get } from 'lodash';

class AnaliseReportModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      analise: '',
      coloredProperty: 'bisserial',
      itensAnalise: [],
      sortedItens: []
    };
    this.componentToPrintRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const { itens, parametros } = this.props;
    if (prevProps.itens !== itens || prevProps.parametros !== parametros) {
      const showTable = itens.length && parametros.length;
      if (showTable) {
        this.setState({
          showTable,
          itensAnalise: this.itensAnalise
        });
        this.addItensExtraFields();
      }
    }
  }

  onParameterSelect = (e) => {
    const selectedParameter = e.target.id;
    this.setState({
      coloredProperty: selectedParameter
    });
  };

  get itensAnalise() {
    const { itens } = this.props;
    return itens.map((item) => this.standarizeItem(item));
  }

  mergeFieldsWithItems(itensWithFields) {
    const { itensAnalise } = this.state;
    let newItens = [];
    itensWithFields.map((item) => {
      itensAnalise.map((oldItem) => {
        if (item.id === oldItem.id) {
          newItens.push({ ...item, ...oldItem });
        }
      });
    });
    this.setState({
      itensAnalise: newItens
    });
  }

  addItensExtraFields() {
    const { itens } = this.props;
    const extraFields = [
      'id',
      'disciplina_name',
      'dificuldade',
      'dificuldade_name',
      'matriz_referencia',
      'habilidade_name',
      'competencias',
      'analise'
    ];
    const itensIds = itens.map((item) => item.id);
    axios
      .get(`${API_HOST}/itens/item/specific_values`, {
        params: {
          itens: itensIds.join(),
          fields: extraFields.join()
        }
      })
      .then((response) => {
        this.mergeFieldsWithItems(response.data);
      });
  }

  get colorMap() {
    const { itensAnalise } = this.state;
    const coloredColumn = 1;
    const headerOffset = 2;
    return itensAnalise.map((item, index) => {
      const cellColor = this.cellColor(item);
      return {
        x: coloredColumn,
        y: index + headerOffset,
        color: rgbToArgb(cellColor)
      };
    });
  }

  formatItensToExport = (itens) => {
    // Formats itens columns to be more user friendly
    return itens.map((item) => {
      return {
        'Posição do Item na Prova': item.posicao,
        'Item no Educat': item.id,
        'Acertos(%)': item.dificuldade,
        'Dificuldade Real': item.nivel_dificuldade,
        'Dificuldade Presumida': item.dificuldade_name,
        Bisserial: item.bisserial,
        'Nível Bisserial': item.nivel_bisserial,
        Discriminação: item.discriminacao,
        'Nível de Discriminação': item.nivel_discriminacao,
        'Disciplina / Eixo': item.disciplina_name,
        Habilidades: item.habilidade_name,
        Competências: item.competencias,
        'Matriz de Referência': item.matriz_referencia,
        Descrição: item.analise_item
      };
    });
  };

  mergeItens = (itens) => {
    return itens.map((item) => {
      let analiseItem = '';
      const color = [
        {
          name: 'Muito Fácil',
          min_dificuldade: 85,
          max_dificuldade: 100,
          color: '#52CE50'
        },
        {
          name: 'Fácil',
          min_dificuldade: 65,
          max_dificuldade: 85,
          color: '#267ed1'
        },
        {
          name: 'Médio',
          min_dificuldade: 35,
          max_dificuldade: 65,
          color: '#ff8e2e'
        },
        {
          name: 'Difícil',
          min_dificuldade: 15,
          max_dificuldade: 35,
          color: '#aa3f3e'
        },
        {
          name: 'Muito Difícil',
          min_dificuldade: 0,
          max_dificuldade: 15,
          color: '#8470FF'
        }
      ];
      const dificuldadeResult = {
        ...item,
        dificuldade: color.filter(
          (d) => d.name === get(item, 'dificuldade_name')
        )[0]
      };

      const discriminacaoNivel =
        get(item, 'nivel_discriminacao') === 'Discriminação muito boa' ||
        get(item, 'nivel_discriminacao') === 'Discriminação boa' ||
        get(item, 'nivel_discriminacao') === 'Discriminação baixa' ||
        get(item, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
        get(item, 'nivel_discriminacao') === 'Não Discrimina';

      const bisserialNivel =
        get(item, 'nivel_bisserial') === 'Bisserial muito bom' ||
        get(item, 'nivel_bisserial') === 'Bisserial bom' ||
        get(item, 'nivel_bisserial') === 'Bisserial baixo' ||
        get(item, 'nivel_bisserial') === 'Bisserial muito baixo';

      const sameData =
        (get(item, 'dificuldade_name') === 'Fácil' &&
          get(item, 'nivel_dificuldade') === 'Difícil') ||
        get(item, 'nivel_dificuldade') === 'Muito Difícil' ||
        (get(item, 'dificuldade_name') === 'Médio' &&
          get(item, 'nivel_dificuldade') === 'Difícil') ||
        get(item, 'nivel_dificuldade') === 'Muito Difícil' ||
        (get(item, 'dificuldade_name') === 'Difícil' &&
          get(item, 'nivel_dificuldade') === 'Muito Difícil');

      const nivelDificil =
        get(item, 'dificuldade_name') === 'Difícil' &&
        get(item, 'nivel_dificuldade') === 'Difícil';

      const nivelFacil =
        get(item, 'dificuldade_name') === 'Fácil' &&
        get(item, 'nivel_dificuldade') === 'Fácil';

      const dificuldadeModulos =
        (get(item, 'dificuldade_name') === 'Fácil' &&
          get(item, 'nivel_dificuldade') === 'Difícil') ||
        (get(item, 'dificuldade_name') === 'Médio' &&
          get(item, 'nivel_dificuldade') === 'Difícil');

      const dificuldadeModulo2 =
        (get(item, 'dificuldade_name') === 'Fácil' &&
          get(item, 'nivel_dificuldade') === 'Muito Difícil') ||
        (get(item, 'dificuldade_name') === 'Médio' &&
          get(item, 'nivel_dificuldade') === 'Muito Difícil') ||
        (get(item, 'dificuldade_name') === 'Difícil' &&
          get(item, 'nivel_dificuldade') === 'Muito Difícil');

      const dificuldadePresumidaMaior =
        (get(item, 'dificuldade_name') === 'Fácil' &&
          get(item, 'nivel_dificuldade') === 'Muito Fácil') ||
        (get(item, 'dificuldade_name') === 'Médio' &&
          get(item, 'nivel_dificuldade') === 'Fácil') ||
        get(item, 'nivel_dificuldade') === 'Muito Fácil' ||
        (get(item, 'dificuldade_name') === 'Difícil' &&
          get(item, 'nivel_dificuldade') === 'Fácil') ||
        get(item, 'nivel_dificuldade') === 'Muito Fácil' ||
        get(item, 'nivel_dificuldade') === 'Médio';

      // 1
      if (
        (get(item, 'dificuldade_name') === 'Fácil' &&
          get(item, 'nivel_dificuldade') === 'Fácil') ||
        (get(item, 'dificuldade_name') === 'Médio' &&
          get(item, 'nivel_dificuldade') === 'Médio' &&
          discriminacaoNivel &&
          bisserialNivel)
      ) {
        analiseItem = 'Item adequado';
      }
      // 2
      else if (
        nivelDificil &&
        (get(item, 'nivel_discriminacao') === 'Discriminação muito boa' ||
          get(item, 'nivel_discriminacao') === 'Discriminação boa' ||
          get(item, 'nivel_discriminacao') === 'Discriminação baixa') &&
        bisserialNivel
      ) {
        analiseItem = 'Item adequado';
      }
      // 3
      else if (
        nivelDificil &&
        (get(item, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
          get(item, 'nivel_discriminacao') === 'Não Discrimina') &&
        (get(item, 'nivel_bisserial') === 'Bisserial muito bom' ||
          get(item, 'nivel_bisserial') === 'Bisserial bom')
      ) {
        analiseItem = 'Item adequado';
      }
      // 4
      else if (
        nivelDificil &&
        (get(item, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
          get(item, 'nivel_discriminacao') === 'Não Discrimina') &&
        (get(item, 'nivel_bisserial') === 'Bisserial baixo' ||
          get(item, 'nivel_bisserial') === 'Bisserial muito baixo')
      ) {
        analiseItem = 'Item com inadequações';
      }
      // 5
      else if (
        get(item, 'dificuldade_name') !== get(item, 'nivel_dificuldade') &&
        dificuldadePresumidaMaior &&
        get(dificuldadeResult, 'dificuldade.max_dificuldade') <=
          get(item, 'dificuldade') &&
        bisserialNivel &&
        discriminacaoNivel
      ) {
        analiseItem = 'Item adequado com ponderações';
      }
      // 6
      else if (
        get(item, 'dificuldade_name') === 'Fácil' &&
        get(item, 'nivel_dificuldade') === 'Médio' &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
          get(item, 'dificuldade') <
          get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        bisserialNivel &&
        discriminacaoNivel
      ) {
        analiseItem = 'Item adequado com ponderações';
      }
      // 7 - 1 modulo
      else if (
        dificuldadeModulos &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
          get(item, 'dificuldade') <=
          get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        bisserialNivel &&
        (get(item, 'nivel_discriminacao') === 'Discriminação muito boa' ||
          get(item, 'nivel_discriminacao') === 'Discriminação boa' ||
          get(item, 'nivel_discriminacao') === 'Discriminação baixa')
      ) {
        analiseItem = 'Item adequado com ponderações';
      }
      // 7 - 2 modulo
      else if (
        dificuldadeModulo2 &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
          get(item, 'dificuldade') <=
          get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        (get(item, 'nivel_bisserial') === 'Bisserial muito bom' ||
          get(item, 'nivel_bisserial') === 'Bisserial bom' ||
          get(item, 'nivel_bisserial') === 'Bisserial baixo') &&
        (get(item, 'nivel_discriminacao') === 'Discriminação muito boa' ||
          get(item, 'nivel_discriminacao') === 'Discriminação boa' ||
          get(item, 'nivel_discriminacao') === 'Discriminação baixa')
      ) {
        analiseItem = 'Item adequado com ponderações';
      }
      // 8
      else if (
        sameData &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
          get(item, 'dificuldade') <=
          get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        (get(item, 'nivel_bisserial') === 'Bisserial muito bom' ||
          get(item, 'nivel_bisserial') === 'Bisserial bom') &&
        (get(item, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
          get(item, 'nivel_discriminacao') === 'Não Discrimina')
      ) {
        analiseItem = 'Item adequado com ponderações';
      }
      // 9 - 1 modulo
      else if (
        dificuldadeModulos &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
          get(item, 'dificuldade') <=
          get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        (get(item, 'nivel_bisserial') === 'Bisserial baixo' ||
          get(item, 'nivel_bisserial') === 'Bisserial muito baixo') &&
        (get(item, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
          get(item, 'nivel_discriminacao') === 'Não Discrimina')
      ) {
        analiseItem = 'Item com inadequações';
      }
      // 9 - 2 modulo
      else if (
        dificuldadeModulo2 &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
          get(item, 'dificuldade') <=
          get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        (get(item, 'nivel_bisserial') === 'Bisserial baixo' ||
          get(item, 'nivel_bisserial') === 'Bisserial muito baixo') &&
        (get(item, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
          get(item, 'nivel_discriminacao') === 'Não Discrimina')
      ) {
        analiseItem = 'Incompátivel';
      }
      // 10
      else if (
        dificuldadePresumidaMaior &&
        get(dificuldadeResult, 'dificuldade.max_dificuldade') <
          get(item, 'dificuldade') &&
        discriminacaoNivel &&
        (get(item, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(item, 'nivel_bisserial') === 'Bisserial inadequado')
      ) {
        analiseItem = 'Item com inadequações';
      }
      // 11
      else if (
        nivelFacil &&
        discriminacaoNivel &&
        (get(item, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(item, 'nivel_bisserial') === 'Bisserial inadequado')
      ) {
        analiseItem = 'Item com inadequações';
      }
      // 12
      else if (
        get(item, 'dificuldade_name') === get(item, 'nivel_dificuldade') &&
        nivelDificil &&
        discriminacaoNivel &&
        (get(item, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(item, 'nivel_bisserial') === 'Bisserial inadequado')
      ) {
        analiseItem = 'Item incompatível';
      }
      // 13
      else if (
        sameData &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
          get(item, 'dificuldade') <=
          get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        discriminacaoNivel &&
        (get(item, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(item, 'nivel_bisserial') === 'Bisserial inadequado')
      ) {
        analiseItem = 'Item incompatível';
      }
      // 14
      else if (
        get(item, 'dificuldade_name') === 'Médio' &&
        get(item, 'nivel_dificuldade') === 'Médio' &&
        (get(item, 'nivel_discriminacao') === 'Discriminação baixa' ||
          get(item, 'nivel_discriminacao') === 'Discriminação boa' ||
          get(item, 'nivel_discriminacao') === 'Discriminação muito boa') &&
        (get(item, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(item, 'nivel_bisserial') === 'Bisserial inadequado')
      ) {
        analiseItem = 'Item com inadequações';
      }
      // 15
      else if (
        get(item, 'dificuldade_name') === get(item, 'nivel_dificuldade') &&
        get(item, 'dificuldade_name') === 'Médio' &&
        get(item, 'nivel_dificuldade') === 'Médio' &&
        (get(item, 'nivel_discriminacao') === 'Não Discrimina' ||
          get(item, 'nivel_discriminacao') === 'Discriminação muito baixa') &&
        (get(item, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(item, 'nivel_bisserial') === 'Bisserial inadequado')
      ) {
        analiseItem = 'Item incompatível';
      }
      // 16
      if (
        get(item, 'dificuldade_name') === 'Difícil' &&
        get(item, 'nivel_dificuldade') === 'Médio' &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
          get(item, 'dificuldade') <=
          get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        (get(item, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(item, 'nivel_bisserial') === 'Bisserial inadequado') &&
        (get(item, 'nivel_discriminacao') === 'Discriminação baixa' ||
          get(item, 'nivel_discriminacao') === 'Discriminação boa' ||
          get(item, 'nivel_discriminacao') === 'Discriminação muito boa')
      ) {
        analiseItem = 'Item com inadequações';
      }
      // 17
      else if (
        get(item, 'dificuldade_name') === 'Difícil' &&
        get(item, 'nivel_dificuldade') === 'Médio' &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
          get(item, 'dificuldade') <=
          get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        (get(item, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(item, 'nivel_bisserial') === 'Bisserial inadequado') &&
        (get(item, 'nivel_discriminacao') === 'Discriminação baixa' ||
          get(item, 'nivel_discriminacao') === 'Não Discrimina')
      ) {
        analiseItem = 'Item incompatível';
      }
      // 18
      if (
        get(item, 'dificuldade_name') === 'Fácil' &&
        get(item, 'nivel_dificuldade') === 'Médio' &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
          get(item, 'dificuldade') <=
          get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        (get(item, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(item, 'nivel_bisserial') === 'Bisserial inadequado') &&
        (get(item, 'nivel_discriminacao') === 'Discriminação muito boa' ||
          get(item, 'nivel_discriminacao') === 'Discriminação boa' ||
          get(item, 'nivel_discriminacao') === 'Discriminação baixa')
      ) {
        analiseItem = 'Item com inadequações';
      }
      // 19
      else if (
        get(item, 'dificuldade_name') === 'Fácil' &&
        get(item, 'nivel_dificuldade') === 'Médio' &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >
          get(item, 'dificuldade') <
          get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        (get(item, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(item, 'nivel_bisserial') === 'Bisserial inadequado') &&
        (get(item, 'nivel_discriminacao') === 'Não Discrimina' ||
          get(item, 'nivel_discriminacao') === 'Discriminação muito baixa')
      ) {
        analiseItem = 'Item incompatível';
      }

      const mergeItem = {
        ...item,
        analise: analiseItem
      };

      return {
        posicao: mergeItem.posicao,
        id: mergeItem.id,
        dificuldade: mergeItem.dificuldade,
        nivel_dificuldade: mergeItem.nivel_dificuldade,
        dificuldade_name: mergeItem.dificuldade_name,
        bisserial: mergeItem.bisserial,
        nivel_bisserial: mergeItem.nivel_bisserial,
        discriminacao: mergeItem.discriminacao,
        nivel_discriminacao: mergeItem.nivel_discriminacao,
        disciplina_name: mergeItem.disciplina_name,
        analise_item: mergeItem.analise,
        habilidade_name: mergeItem.habilidade_name,
        competencias: mergeItem.competencias,
        matriz_referencia: mergeItem.matriz_referencia,
        cor_bisserial: mergeItem.cor_bisserial,
        cor_discriminacao: mergeItem.cor_discriminacao,
        cor_dificuldade: mergeItem.cor_dificuldade,
        frequencia: mergeItem.frequencia
      };
    });
  };

  onSorting = (rows) => {
    this.setState({
      sortedItens: rows
    });
  };

  cellColor = (item) => {
    const { coloredProperty } = this.state;
    return coloredProperty ? item[`cor_${coloredProperty}`] : null;
  };

  standarizeItem = (item) => {
    const { parametros } = this.props;
    const { gabarito } = item;
    const posicao = item.posicao_corrigida - 1;
    const analiseDoItem = parametros[posicao][gabarito];
    return {
      posicao: item.posicao_corrigida,
      id: item.id,
      ...analiseDoItem
    };
  };

  reportColumns = [
    { title: 'Número', key: 'posicao', order_by: true },
    { title: 'Item no Educat', key: 'id', order_by: true },
    { title: 'Acerto (%)', key: 'dificuldade', order_by: true },
    { title: 'Bisserial', key: 'bisserial', order_by: true },
    { title: 'Discriminação', key: 'discriminacao', order_by: true },
    { title: 'Nível Bisserial', key: 'nivel_bisserial', order_by: false },
    { title: 'Dificuldade Real', key: 'nivel_dificuldade', order_by: false },
    {
      title: 'Matriz de Referência',
      key: 'matriz_referencia',
      order_by: false
    },
    { title: 'Habilidades', key: 'habilidade_name' },
    { title: 'Competências', key: 'competencias' },
    {
      title: 'Dificuldade Presumida',
      key: 'dificuldade_name',
      order_by: false
    },
    {
      title: 'Nível Discriminação',
      key: 'nivel_discriminacao',
      order_by: false
    },
    { title: 'Disciplina / Eixo', key: 'disciplina_name', order_by: false },
    { title: 'Descrição', key: 'analise_item', order_by: false }
  ];

  render() {
    const { isOpen, onClose, title } = this.props;
    const { coloredProperty, itensAnalise, sortedItens } = this.state;
    const mergedItens = this.mergeItens(itensAnalise);
    const itensToExport = sortedItens.length > 0 ? sortedItens : mergedItens;

    return (
      <Modal isOpen={isOpen} toggle={onClose} size="xl">
        <ModalHeader toggle={onClose}>Relatório da Análise</ModalHeader>
        <ModalBody>
          <div ref={this.componentToPrintRef}>
            <div className="d-md-flex">
              <h5
                style={{
                  textAlign: 'center',
                  marginTop: '20px'
                }}
              >
                {title}
              </h5>
            </div>
            <AnaliseParameterPicker
              onSelect={this.onParameterSelect}
              checkedParameter={coloredProperty}
            />
            <AnaliseReportLegenda selectedParameter={coloredProperty} />
            <AnaliseReportExportMenu
              componentToPrint={this.componentToPrintRef}
              dataToExport={this.formatItensToExport(itensToExport)}
              colorMap={this.colorMap}
            />
            {this.state.showTable && (
              <AnaliseReportTable
                columns={this.reportColumns}
                rows={mergedItens}
                coloredProperty={coloredProperty}
                handleSorting={this.onSorting}
              />
            )}
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

AnaliseReportModal.propTypes = {
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  itens: PropTypes.array,
  parametros: PropTypes.array,
  totalCandidatos: PropTypes.number
};

AnaliseReportModal.defaultProps = {
  title: '',
  isOpen: false,
  onClose: () => {},
  itens: [],
  parametros: [],
  totalCandidatos: 0
};

export default AnaliseReportModal;
